import { render, staticRenderFns } from "./UnsubscriptionReport.vue?vue&type=template&id=57a4584c&"
import script from "./UnsubscriptionReport.vue?vue&type=script&lang=js&"
export * from "./UnsubscriptionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports